import api from "@src/api/api";
import { signOut } from "@src/state/user/userSlice";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const LogoutContainer = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const queryClient = useQueryClient();

  const logoutMutation = useMutation(["login"], {
    mutationFn: async () => {
      return await api.get("/api/v1/auth/logout");
    },
    onSuccess: () => {
      navigate("/news");
      dispatch(signOut());
      queryClient.invalidateQueries({ queryKey: ["me"] });
    },
    onError: () => {
      alert("Failed");
    },
  });

  useEffect(() => {
    logoutMutation.mutate();
  }, []);

  return <div>Logout ...</div>;
};

export default LogoutContainer;
